import {Map, List} from 'immutable';

import {
  ACCOUNT_LIST_REQUEST,
  ACCOUNT_LIST_SUCCESS,
  ACCOUNT_LIST_FAILURE,
  ACCOUNT_READ_REQUEST,
  ACCOUNT_READ_SUCCESS,
  ACCOUNT_READ_FAILURE,
  ACCOUNT_UPDATE_REQUEST,
  ACCOUNT_UPDATE_SUCCESS,
  ACCOUNT_UPDATE_FAILURE,
  ACCOUNT_CREATE_REQUEST,
  ACCOUNT_CREATE_SUCCESS,
  ACCOUNT_CREATE_FAILURE,
  ACCOUNT_DELETE_REQUEST,
  ACCOUNT_DELETE_SUCCESS,
  ACCOUNT_DELETE_FAILURE,
  ACCOUNT_FORM_DESTROY,
  ACCOUNT_CSV_DOWNLOAD_REQUEST,
  ACCOUNT_CSV_DOWNLOAD_SUCCESS,
  ACCOUNT_CSV_DOWNLOAD_FAILURE
} from './actions'
import Logger from '../../../lib/Logger';

export default function accounts(
  state=Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {}
  }),
  action
) {
  Logger.log('debug', `[accounts.reducers] accounts(%j, %j)`, state, action);

  switch(action.type) {

    case ACCOUNT_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case ACCOUNT_LIST_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        pages: {
          [action.order]: {
            [action.limit]: {
              [action.page]: null
            }
          }
        },
        total: action.total,
        lastUpdated: action.receivedAt
      }).setIn(['pages', action.order, action.limit, action.page], List(action.result));

    case ACCOUNT_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case ACCOUNT_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case ACCOUNT_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case ACCOUNT_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case ACCOUNT_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case ACCOUNT_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case ACCOUNT_UPDATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case ACCOUNT_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case ACCOUNT_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case ACCOUNT_CREATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case ACCOUNT_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case ACCOUNT_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case ACCOUNT_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case ACCOUNT_FORM_DESTROY:
      return state.mergeDeep({
        form: null
      }).set('form', action.form);

    case ACCOUNT_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true
      });

    case ACCOUNT_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case ACCOUNT_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `accounts.reducers loaded.`);
